import { Component, Input, OnInit } from '@angular/core';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { loadProducts } from '@app/actions/shoppingmall/product.action';
import { AuthUtil } from '@app/common/util/auth.util';
import { ConvertUtil } from '@app/common/util/convert.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { SmWownetModel } from '@app/models/system/sm-wownet.model';
import { OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { ProductState, getProducts } from '@app/selectors/shoppingmall/product.selector';
import { SmWownetState, getSmWownet } from '@app/selectors/system/sm-wownet.selector';
import { environment } from '@enviroments/environment';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'hp-brand',
  templateUrl: './hp-brand.component.html',
  styleUrls: ['./hp-brand.component.css']
})
export class HpBrandComponent implements OnInit {

  smWownet$ = new Observable<SmWownetModel>();
  smWownet: any = {} as SmWownetModel;
  urlWownet : String = "";

  products$ = new Observable<OrdPdtModel[]>();
	products: OrdPdtModel[] = [];

  page: number = 1;
	len: number = 1000;

  constructor(
    private _overlayLoadingStore: Store<OverlayLoadingState>,
    private _smWownetStateStore: Store<SmWownetState>,
    private _productStore: Store<ProductState>,
  ) { 
    this.smWownet$ = this._smWownetStateStore.select(getSmWownet);
    this.products$ = this._productStore.select(getProducts);
  }

  ngOnInit(): void {
    this.smWownet$.subscribe((res) => {
      if (ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.urlWownet = res.urlWownet;
        this.smWownet = res;
      }
    });

    this.loadProducts();

    this.products$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.products = res;
        this.filterProducts();
      }
      this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
    });
  }

  filterProducts() {
    const orderedProducts = ['RBS19', 'RBS18', 'RBS21']; // Mảng xác định thứ tự mong muốn

    // Lọc và sắp xếp các sản phẩm theo thứ tự mong muốn
    this.products = this.products.filter(product => orderedProducts.includes(ConvertUtil.convertToSring(product.pdtCD)))
                                   .sort((a, b) => orderedProducts.indexOf(ConvertUtil.convertToSring(a.pdtCD)) - orderedProducts.indexOf(ConvertUtil.convertToSring(b.pdtCD)));
  }

  loadProducts(): void {
		this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
		this._productStore.dispatch(loadProducts({ params: this.getParams() }));
	}

  getParams(): any {
    const params = {
        comId: environment.comId,
        cateCd: '',
        pathKind: "PC",
        key: "",
        page: this.page - 1,
        len: this.len,
        userId: AuthUtil.getUserId()
    }
    return params;
  }

}
